import { createSlice } from "@reduxjs/toolkit";

// Utilizzato da ActivityDetails per impedire che AllActivities
// riesegua la fetch quando l'utente torna indietro
export const backlinkSlice = createSlice({
    name: 'backlink',
    initialState: {
        link: null
    },
    reducers: {
        setBacklink: (state, action) => {
            state.link = action.payload
        },
        resetBacklink: (state) => {
            state.link = null
        }
    }
});

export const { setBacklink, resetBacklink } = backlinkSlice.actions;
export default backlinkSlice.reducer;